import { render, staticRenderFns } from "./InformationCollapse.vue?vue&type=template&id=04722cc1&scoped=true"
import script from "./InformationCollapse.vue?vue&type=script&lang=js"
export * from "./InformationCollapse.vue?vue&type=script&lang=js"
import style0 from "./InformationCollapse.vue?vue&type=style&index=0&id=04722cc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04722cc1",
  null
  
)

export default component.exports